import classnames from 'classnames';
import { memo, useLayoutEffect, useRef, useState } from 'react';

const fontSize = 12;

const Username = ({ name = '' }: { name: string }) => {
  const [width, setWidth] = useState(0);
  const ref = useRef<HTMLSpanElement>(null);

  useLayoutEffect(() => {
    if (!ref.current) return;

    setWidth(ref.current.offsetWidth);
  }, []);

  return (
    <section className="user-name flex max-w-[25vw] overflow-hidden">
      <div
        className={classnames(
          'm-0 inline-block overflow-hidden text-ellipsis whitespace-nowrap align-bottom text-black dark:text-white'
        )}
        style={{
          maxWidth: width || 0,
          transition: 'max-width 0.15s ease-out',
          transitionDelay: name ? '0s' : '0.5s',
          willChange: 'max-width',
          fontSize,
        }}
      >
        <span ref={ref}>{name}</span>
      </div>
    </section>
  );
};

export default memo(Username, (prev, next) => prev.name === next.name);
